import { connect } from 'react-redux';

import { About } from './index';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export interface IDescriptionStoreProps {
  description: string;
  siteUrl?: string;
}

export interface IDescriptionDispatchProps {
  setNavigationLink(): void;
}

function mapStateToProps(state: IState): IDescriptionStoreProps {
  const { village } = state.villageData;

  return {
    description: village.description ?? '',
    siteUrl: village.siteUrlUtm || village.siteUrl,
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch): IDescriptionDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.About)),
  };
}

export const AboutContainer = connect<IDescriptionStoreProps, IDescriptionDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(About);
